import React from 'react';
import * as debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import QuickSearch from '../Components/QuickSearch';
import { query, setSearchQuery } from '../Actions/QuickSearch.action';

const QuickSearchContainer = props => {
    const { query, setSearchQuery, onSearch } = props
    var searchContainer

    React.useEffect(() => {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            setSearchQuery(query);
            onSearch(query)
        }
    }, [])

    const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '')

    return <div ref={(elem) => searchContainer = elem}>
        <QuickSearch {...props} searchUrl={searchUrl} />
    </div>
}

const mapStateToProps = state => {
    return {
        query: state.quickSearch.query,
        result: state.quickSearch.result,
        showAll: state.quickSearch.showAll,
        noHit: state.quickSearch.noHit,
        isLoading: state.quickSearch.isLoading,
        showResult: state.quickSearch.showResult,
    }
}

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const mapDispatchToProps = dispatch => {
    return {
        onSearch: (text) => {
            dispatch(setSearchQuery(text));
            debouncedQuery(dispatch, text);
        },
        setSearchQuery: (text) => dispatch(setSearchQuery(text)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickSearchContainer);